import React, { Component } from "react";
import PropTypes from "prop-types";
import jobDetailStyle from "../../assets/jss/jobDetailStyle";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { connect } from 'react-redux'
import {
    getJobDetail,
    editJob,
    doneEdit
} from '../../actions/JobActions'
import {
    getEntities,
    getJobCategories
} from '../../actions/PositionInformationActions'
import AdminJobDetailForm from '../form/AdminJobDetailForm'
import {
    NavLink,
} from 'react-router-dom'
import {
    ROUTE_ADMIN_JOB_DETAIL,
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_ADMIN_CREATE_JOB
} from '../../utils/routes'
import InformationDialog from '../../components/Dialog/InformationDialog'
import {
    logout
} from '../../actions/LoginAction'

class AdminJobDetail extends Component {

    constructor() {
        super();
        this.state = {
          open: false,
          categories: []
        }
    }

    componentWillMount() {
        const { match: { params } } = this.props
        const id = params.id;
        this.props.getJobDetail(id)
        this.props.getEntities()
        this.props.getJobCategories()
    }

    componentWillReceiveProps(nextPorps){
        const categories_arr =  Object.keys(nextPorps.categories)
        this.setState({
            categories: categories_arr
        })
    }



    render() {

        const {
            classes,
            job: { edit },
            match: { params }, 
            entities,
            form_data,
        } = this.props;

        return (

            <div className={classes.adminContent}>

                <InformationDialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    handleLogout={this.handleLogout}
                />

                <div className="CvBtn">

                <NavLink from={ROUTE_ADMIN_JOB_DETAIL} to={ROUTE_REQUISITION_LIST}>
                    <Button variant="outlined" className={classes.nav_button} color="secondary">
                        View Requisitions
                    </Button>
                </NavLink>

                <NavLink  from={ROUTE_ADMIN_JOB_DETAIL} to={ROUTE_ADMIN_JOB}>
                    <Button variant="outlined" className={classes.nav_button}  color="secondary">
                        View Jobs
                    </Button>
                </NavLink>
                <NavLink  from={ROUTE_ADMIN_JOB_DETAIL} to={ROUTE_ADMIN_CREATE_JOB}>
                    <Button  variant="outlined" className={classes.nav_button}  color="secondary">
                        Create Job
                    </Button>
                </NavLink>

                <NavLink from={ROUTE_ADMIN_JOB_DETAIL} to={ROUTE_ADMIN_CV}>
                    <Button variant="outlined" className={classes.nav_button} color="secondary">
                        View CVs
                    </Button>
                </NavLink>

                <Button 
                    onClick={() => this.onLogout()}
                    variant="outlined" 
                    className={classes.nav_button} 
                    color="secondary">
                        Logout
                </Button>
                </div>
                <div className="CvBtn">

                    {
                        edit ? (
                            <Button
                                className={classes.edit_button}
                                variant="outlined"
                                color="secondary"
                                onClick={() => this.handleEditInfo()}
                            >
                                Done
                            </Button>
                        ) : (
                                <Button
                                    className={classes.edit_button}
                                    variant="outlined"
                                    color="secondary"
                                    onClick={() => this.props.editJob(!edit)}
                                >
                                    Edit Info
                            </Button>
                            )
                    }

                </div>
                <div className={classes.main}>
                    <AdminJobDetailForm
                        loadData={this.props.loadData}
                        id={params.id}
                        entities={entities}
                        category_list = {this.state.categories}
                        category={form_data.category}
                        benefits={form_data.benefits}
                        type={form_data.contract === undefined ? "full" : form_data.contract.type}
                        edit={edit}
                        description={form_data.description === undefined ? "" : form_data.description}
                        requirements={form_data.requirements === undefined ? "" : form_data.requirements}
                    />
                </div>
            </div>
        )
    }

    handleEditInfo = () => {
        const { form_data } = this.props
        this.props.doneEdit(form_data)
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
      //  this.props.history.push(ROUTE_ADMIN_LOGIN);

    }

}

AdminJobDetail.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => ({
    getJobDetail: (prop) => {
        dispatch(
            getJobDetail(prop)
        )
    },
    getEntities: () => {
        dispatch(
            getEntities()
        )
    },
    getJobCategories: () => {
        dispatch(
            getJobCategories()
        )
    },
    editJob: (edit) => {
        dispatch(
            editJob(edit)
        )
    },
    doneEdit: (prop) => {
        dispatch(
            doneEdit(prop, function() {
                window.location.reload(false);

            })
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
})

const mapStateToProps = (state) => ({
    job: state.jobs,
    entities: state.requisition.entities,
    categories: state.requisition.category_list,
    form_data: state.form.AdminJobDetail === undefined ? {} : state.form.AdminJobDetail.values
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(jobDetailStyle)(AdminJobDetail));